import { connect } from 'react-redux'
import ActiveVehicle from './ActiveVehicle'
import { getUserData } from 'components/Appointment/selectors'

const mapStateToProps = (state) => {
  const { isPilotStore } = getUserData(state)

  return {
    isPilotStore,
    isNumberOfTiresLoading: state.availableTires.isNumberOfTiresLoading
  }
}

export default connect(mapStateToProps)(ActiveVehicle)
